import { render } from "./HeroiconsOutlineHand.vue?vue&type=template&id=f2c03644"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineHand.vue"]])

export default __exports__